// extracted by mini-css-extract-plugin
module.exports = {"ArLegalText":"legal-ar-text_ArLegalText__7CqRM"};